import type { ListOrdersAdminInput } from '@repo/api-contracts';
import { type ReactElement, useState } from 'react';
import { useNavigate } from 'react-router';
import { useOrdersListQuery } from '@/entities/order';
import { PageHeader } from '@/shared/ui';
import { OrderList } from '@/widgets/order-list';

const DEFAULT_QUERY: ListOrdersAdminInput = {
  page: 1,
  limit: 20,
  filter: 'TO_PROCESS',
  search: '',
};

/**
 * 어드민 주문 목록(주문 설계 §8-5) — 머리말과 목록 조건(쪽·필터·검색어)만 소유하고 도구줄·표는 위젯이 그린다. 주문 번호는 상세
 * (`/orders/:orderId`, 취소 요청 접수 메일의 관리자 링크와 같은 경로)로 간다. 셸(헤더·사이드바·본문 여백)은 레이아웃 라우트가 준다.
 */
export function OrdersPage(): ReactElement {
  const navigate = useNavigate();
  const [query, setQuery] = useState<ListOrdersAdminInput>(DEFAULT_QUERY);
  const list = useOrdersListQuery(query);
  return (
    <>
      <PageHeader
        title="주문 목록"
        description="결제된 주문의 제작·출고·배송과 취소 요청을 처리합니다."
      />
      <OrderList
        data={list.data}
        initialQuery={query}
        onQueryChange={setQuery}
        onOpen={(orderId) => {
          void navigate(`/orders/${orderId}`);
        }}
        pending={list.isFetching}
        error={list.isError ? `주문 목록을 불러오지 못했습니다: ${list.error.message}` : null}
      />
    </>
  );
}
